import dayjs from 'dayjs';
import * as types from '../mutation-types';
import { getHuntByIdInOneClass } from '../../assets/api/cwhunt';

// State object
const state = () => ({
  myhuntByProblemId: {},
});

// Getter functions
const getters = {
  getHuntByDate: (state) => () => {
    const obj = {};
    Object.keys(state.myhuntByProblemId).forEach((i) => {
      state.myhuntByProblemId[i].forEach((j) => {
        const date = dayjs(j.submitTime).format('YYYY-M-D');
        if (!obj[date]) obj[date] = [];
        obj[date].push(j);
      });
    });
    return obj;
  },
};

// Actions
const actions = {
  async getMyHunt({ commit }, { classId, cwId }) {
    try {
      const { data } = await getHuntByIdInOneClass(classId, cwId);
      const obj = {};
      data.forEach((i) => {
        if (undefined === obj[i.problem_id]) {
          obj[i.problem_id] = [];
        }
        obj[i.problem_id].push({
          cwhuntId: i.id,
          problemId: i.problem_id,
          status: i.status,
          submitTime: i.submit_time,
          cw_id: i.cw_id,
          grade: i.grade,
        });
      });
      commit(types.SET_MY_CWHUNT, obj);
    } catch {
      commit(types.SET_MY_CWHUNT, {});
    } finally {
      //
    }
  },
};

// Mutations
const mutations = {
  [types.SET_MY_CWHUNT](state, payload) {
    state.myhuntByProblemId = { ...payload };
  },
  [types.CLEAR_MY_CWHUNT](state) {
    state.myhuntByProblemId = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
